module.exports = __webpack_public_path__ + "static/approves2-0e448d8995ab0041d3bc4538c81bc5bf.gif";